"use client";

import { BadgeCheck, User } from "lucide-react";
import Image from "next/image";
import Link from "next/link";

export default function DeveloperCard({ developer, isArabic }: any) {
  if (!developer) return null;

  return (
    <div className="w-full">
      {/* Divider */}
      <div className="h-px bg-gray-100 mb-6" />

      <div className="flex items-center justify-between gap-4">
        {/* Avatar + Name */}
        <div className="flex items-center gap-3">
          <div className="relative w-14 h-14 rounded-full overflow-hidden border-2 border-gray-100 bg-gray-50 flex items-center justify-center shrink-0">
            {developer?.photo ? (
              <Image
                src={developer.photo}
                alt={developer?.username || "Developer"}
                fill
                className="object-cover"
              />
            ) : (
              <User className="text-gray-300 w-6 h-6" />
            )}
          </div>

          <div>
            <p className="text-xs text-gray-400 mb-0.5">المطور العقاري</p>
            <h3 className="text-base font-bold text-gray-900 leading-tight flex items-center gap-1.5 flex-wrap">
              {developer?.username || "اسم المطور"}
              {developer?.falLicense?.verified && (
                <span
                  title={`رخصة فال ${developer.falLicense.number ? "#" + developer.falLicense.number : ""}`}
                  className="inline-flex items-center gap-1 rounded-full bg-emerald-50 px-2 py-0.5 text-[10px] font-black text-emerald-700 ring-1 ring-emerald-200"
                >
                  <BadgeCheck size={12} /> {isArabic ? "مرخّص من الهيئة" : "REGA licensed"}
                </span>
              )}
            </h3>
          </div>
        </div>

        {/* CTA Button */}
        <Link href={`/developer/${developer?.slug}/units`} className="shrink-0">
          <button className="bg-[#111] text-white text-xs font-bold px-5 py-2.5 rounded-xl hover:bg-blue-600 transition-colors duration-200 whitespace-nowrap cursor-pointer">
            {isArabic ? "عرض الوحدات" : "View Units"}
          </button>
        </Link>
      </div>

      {/* Divider */}
      <div className="h-px bg-gray-100 mt-6" />
    </div>
  );
}
